import { lazy } from "react";
import paths from "../paths";

const Search = lazy(() => import("pages/search/index"));
const Product = lazy(() => import("pages/Product"));
const Products = lazy(() => import("pages/Products").then(module => ({ default: module.Products })));
const WinningProducts = lazy(() =>
  import("pages/WinningProducts").then(module => ({ default: module.WinningProducts }))
);
const Import = lazy(() => import("pages/Import").then(module => ({ default: module.Import })));
const Checkout = lazy(() => import("components/Checkout").then(module => ({ default: module.Checkout })));

export const productRoutes = [
  { path: paths.product.index, Component: Search, app: true },
  { path: `${paths.product.index}/:id`, Component: Product, app: true },
  { path: paths.product.products, Component: Products, app: true, shop: true },
  {
    path: paths.product.import,
    Component: Import,
    app: true,
    shop: true
  },
  { path: paths.product.winningProducts, Component: WinningProducts, app: true },
  { path: paths.product.checkout, Component: Checkout, app: true }
];
